import { useRef } from "react";
import { useDispatch } from "react-redux";
import { get } from "lodash";
import { fetchPreviewForAsset } from "actions/content";
import {
  fetchMappingsForContentGrid,
  resetFiltersInContenGrid,
  updateFiltersInContenGrid,
  updateQueryInContenGrid,
} from "actions/contentGrid";
const production = process.env.REACT_APP_DEVELOPMENT === "false";

export const useContentManagerActions = (editorSession) => {
  const dispatch = useDispatch();
  const editorRef = useRef(editorSession);

  const fetchMappings = (contentGrid, page, limit) =>
    dispatch(fetchMappingsForContentGrid(editorRef.current, contentGrid, page, limit, true));

  const fetchPreview = (asset) => dispatch(fetchPreviewForAsset(asset));

  const updateFilters = (contentGrid, filters) =>
    dispatch(updateFiltersInContenGrid(editorRef.current, contentGrid, filters));

  const updateQuery = (contentGrid, query) =>
    dispatch(updateQueryInContenGrid(editorRef.current, contentGrid, query));

  const resetFilters = (contentGrid) =>
    dispatch(resetFiltersInContenGrid(editorRef.current, contentGrid));

  const onContentChange = (content) => {
    const url = get(content, "content.alias");
    const name = get(content, "content.name");
    window.history.replaceState(null, name, url);
  };

  const onAnalyticsChange = (asset, analytics) => {};
  const onDownload = (asset) => console.log(`Download Asset ${asset.id}`);
  const onClose = () => console.log("Close Dialog");

  return {
    debug: !production,
    fetchMappingsForContentGrid: fetchMappings,
    fetchPreviewDataForAsset: fetchPreview,
    updateFiltersInContenGrid: updateFilters,
    updateQueryInContenGrid: updateQuery,
    resetFiltersInContenGrid: resetFilters,
    onContentChange,
    onAnalyticsChange,
    onDownload,
    onClose,
  };
};